import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin } from "lucide-react";

const Footer: React.FC = () => {
  return (
    <footer className="text-white bg-dark-gray">
      <div className="container px-6 py-12 mx-auto">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="flex items-center mb-4 space-x-2">
              <img src="/codeflair-logo.png" alt="Codeflair" className="w-auto h-8" />
              <span className="text-xl font-bold">Codeflair</span>
            </div>
            <p className="mb-4 max-w-md text-gray-300">
              Empowering businesses with cutting-edge web solutions. We create digital experiences that drive growth and innovation.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-300 transition-colors hover:text-blue-400">
                <Facebook size={20} />
              </a>
              <a href="#" className="text-gray-300 transition-colors hover:text-blue-400">
                <Twitter size={20} />
              </a>
              <a href="#" className="text-gray-300 transition-colors hover:text-blue-400">
                <Instagram size={20} />
              </a>
              <a href="#" className="text-gray-300 transition-colors hover:text-blue-400">
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="mb-4 text-lg font-semibold">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 transition-colors hover:text-primary-blue">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 transition-colors hover:text-primary-blue">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 transition-colors hover:text-primary-blue">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 transition-colors hover:text-primary-blue">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="mb-4 text-lg font-semibold">Contact Info</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <Mail size={16} className="text-primary-blue" />
                <span className="text-gray-300">info@codeflair.com</span>
              </div>
              <div className="flex items-center space-x-2">
                <Phone size={16} className="text-primary-blue" />
                <span className="text-gray-300">+91-9414051941</span>
              </div>
              <div className="flex items-center space-x-2">
                <MapPin size={16} className="text-primary-blue" />
                <span className="text-gray-300">Jaipur, India</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 mt-8 text-center border-t border-gray-700">
          <p className="text-gray-300">© 2024 Codeflair. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
